module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-8-d73437109864aaa6d02e08bf777fdf5c.jpg";